import React from 'react';
import styled from 'styled-components';

const FooterWrapper = styled.footer`
  font-family: SUITE;
  width: 100%;
  background-color: #E7E6F4;
  color: #818181;
  bottom: 0;
  padding: 20px;
  box-sizing: border-box;
  font-size: 10px;
  text-align: center;
  overflow-x: hidden;
`;

function Footer() {
  return (
    <FooterWrapper>
      <p>&copy; Bannangco</p>
      <p>대표 : 심윤보 &nbsp; | 개인정보관리책임자 : 심윤보<br/>
      사업자등록번호 : 285-23-02044<br/>
      E-Mail: bannangko@gmail.com | Tel: 010-4210-5104 <br/>
      Location: 경기도 수원시 장안구 서부로 2167번길 28, B04호(율전동)</p>
    </FooterWrapper>
  );
}

export default Footer;
